import {api} from '@/api/index'
//通用模块状态控制
const OSScommonModule = {
    state: {
        ossUploadSignature: {
            // "securityToken": "CAISpgJ1q6Ft5B2yfSjIrKDXDozSqrJnxIrYeEPHoTEMYcReoYjPsTz2IH5Ee3FhAOEav/wymGBV6/Yalrl0U45VAEXfdtM18plM7UaeOz5EFVodru5qsoasPETOIQeZtZagZ4eUZdfZfejXNTKgvyRvwLz8WCy/Vli+S/OggoJmadJlKGvdaiFdVvhbOiF/o8wXKRm0Mu22YDHnnk3aDkdjpnA/6wVF5L+439eX5zfHkVT+0ZV1nYnqJYW+ZMQeW/UaWtyujuttbfiDgmwCqToyrfsu0vcbqGya547EXQQBuC/rabSEroddSyZifbU/FqJ+q/zxqOZ1oOS7lf6slUYSZbAMAniOHN38kJaZSLuzTtEhZKa+Mm/WypWTO4Lp9jw07v/F8ejBrLAagAGHEs48GmYjLoIV8ke8AXe41/b7teS5pXiVLacR9uHB++i3HCnw0aJGSGjBiOq5UaSwUP3hdCDyLAtaKK4Af0ga6UTzopyUXO7UO21x5xpGbEgXuIPfd+J5Ume5KX6ILYNqs3IK4XPW+lyYvV6iAQPrym9+L6344a9qzcZCwfW4Bw==", //sts token
            // "accessKeySecret": "7nS1LxBf1hZhZLj7fHA2EVGEGHr6M2TyMqWdBNULxNCF", //KeySecret
            // "accessKeyId": "STS.McbE6fGmFsH3zevE1YmKrNMdS", //KeyId
            // "expiration": "2017-05-16T05:53:41Z", //过期时间
            // host: process.env.VUE_APP_ENV_NAME === 'PRO' ? 'https://opyx-assp-pro.oss-cn-shenzhen.aliyuncs.com/' : 'http://opyx-assp-test.oss-cn-shenzhen.aliyuncs.com/',
            loading:false,
        },
        sysPlatform:'UC',//oss管理系统平台标识
        businussType:'Public'//业务类型  这里暂定为公开类型
    },
    //激发事件改变state
    mutations: {
        ossUploadSignatureLoadingChange(state, n) {
            state.ossUploadSignature.loading = n === undefined ? !state.ossUploadSignature.loading : !!n
        },
        ossUploadSignatureDataChange(state, n) {
            state.ossUploadSignature = Object.assign(state.ossUploadSignature, n || {
                securityToken: "",
                accessKeySecret: "",
                accessKeyId: "", //签名
                expiration: "",
            });
        },
    },

    //异步操作拿远程数据,然后提交事件
    actions: {
        getFileId(){
          return api.communication.getOssGlobalId()
        },
        loadOssUploadSignature ({commit, state}){
            if(!state.ossUploadSignature.securityToken && state.ossUploadSignature.loading===false){
                commit("ossUploadSignatureLoadingChange",true);
                api.communication.getUploadSignature({}).then(res => {
                    commit("ossUploadSignatureLoadingChange",false);
                    commit("ossUploadSignatureDataChange",res.data);
                })
            }
        }
    },

    //频繁通用计算
    getters: {
    }
}

export default OSScommonModule;
